// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3r2fL","amount":"Amount_amount__UMX_V","tip":"Amount_tip__kT4D9","tipHeader":"Amount_tipHeader__hHwh_","tipsWrap":"Amount_tipsWrap__PLrbW"};